import React from 'react';
import { Button, Col, Drawer, Row, Table, Tag } from 'antd';
import { useState, useEffect } from 'react';
import PageTitle from 'shared_components/page_title';
import DownloadCSV from 'shared_components/download_csv';
import { fetchHospitalItems } from 'services/settings/lookup_table/hospital.jsx';
import HospitalForm from './hospitalForm';

function Hospital() {
	const [hospital, setHospital] = useState([]);
	const [drawerState, setDrawerState] = useState({
		visible: false,
		drawerTitle: '',
		selecetedData: null,
		buttonNames: '',
	});

	const getHospital = async () => {
		const data = await fetchHospitalItems();
		setHospital(data);
	};

	useEffect(() => {
		getHospital();
	}, []);

	const showDrawer = record => {
		setDrawerState({
			visible: true,
			drawerTitle: 'ADD HOSPITAL',
			selecetedData: null,
			buttonNames: 'ADD',
		});
	};

	const displayDrawer = record => {
		setDrawerState({
			visible: true,
			drawerTitle: 'UPDATE HOSPITAL',
			selecetedData: record,
			buttonNames: 'UPDATE',
		});
	};

	const onDrawerClose = () => {
		setDrawerState({
			visible: false,
			drawerTitle: '',
			selecetedData: null,
			buttonNames: '',
		});
	};

	const columns = [
		{
			title: 'HOSPITAL NAME',
			dataIndex: 'hospitalName',
		},
		{
			title: 'ADDRESS',
			dataIndex: 'hospitalAddress',
		},
		{
			title: 'CONTACT No.',
			dataIndex: 'hospitalContactNumber',
		},
		{
			title: 'DATE CREATED',
			dataIndex: 'hospitalCreatedDate',
			render: date => date ? new Date(date).toLocaleDateString() : '',
		},
		{
			title: 'STATUS',
			dataIndex: 'isActive',
			render: active => (
				<Tag color={active === 0 ? 'red' : 'green'}>{active === 0 ? 'INACTIVE' : 'ACTIVE'}</Tag>
			),
		},
	];

	const [openDrawer, setOpenDrawer] = useState(false);

	return (
		<>
			<Row justify="end" style={{ marginTop: 12, marginBottom: 12, display: 'flex', gap: '10px' }}>
				<DownloadCSV
					confirmRequired={true}
					isLookupTable={true}
					confirmDetails={{
						section: 'HOSPITAL',
						count: hospital.length
					}}
					data={hospital}
					filename="hospital_info"
					columns={[
						{ title: 'HOSPITAL NAME', dataIndex: 'hospitalName' },
						{ title: 'ADDRESS', dataIndex: 'hospitalAddress' },
						{ title: 'CONTACT No.', dataIndex: 'hospitalContactNumber' },
						{ 
							title: 'DATE CREATED', 
							dataIndex: 'hospitalCreatedDate',
							render: date => date ? new Date(date).toLocaleDateString() : ''
						},
						{ 
							title: 'STATUS', 
							dataIndex: 'isActive',
							render: active => active === 0 ? 'INACTIVE' : 'ACTIVE'
						}
					]}
				/>
				{/* <Button
					// disabled={buttonDisable}
					type="primary"
					shape="round"
					onClick={showDrawer}
					style={{ marginRight: '15px' }}
					// icon={<PlusOutlined />}
				>
					ADD HOSPITAL
				</Button> */}
				{/* <TablePager handleChange={this.handleChange} /> */}
			</Row>
			<Table
				dataSource={hospital}
				columns={columns}
				pagination={false}
				onRow={record => {
					return {
						onDoubleClick: () => {
							// displayDrawer(record);

							// removed as per sir canil, editting is no longer relevant
						},
					};
				}}
			/>
			<Drawer
				title={drawerState.drawerTitle}
				width="30%"
				visible={drawerState.visible}
				onClose={onDrawerClose}
				destroyOnClose
			>
				<HospitalForm
					buttonNames={drawerState.buttonNames}
					onDrawerClose={onDrawerClose}
					selecetedData={drawerState.selecetedData}
					fetchData={getHospital}
				/>
			</Drawer>
		</>
	);
}

export default Hospital;
